import {
  DOMAIN_LOCALHOST,
  DOMAIN_PUSHWOOSH,
  DOMAIN_WAVESEND,
  DOMAIN_OMO,
  DOMAIN_PUSHWOOSH_US,
  DOMAIN_DEV_MARKERS,
} from './constants';

export function getOrigin(): string {
  return window.location.origin;
}

// Same notion of "dev" that EnvironmentProvider exposes as isDevEnvironment,
// kept in one place next to the other domain constants.
export function isDevOrigin(): boolean {
  const origin = getOrigin();

  return DOMAIN_DEV_MARKERS.some((marker) => origin.includes(marker));
}

export function getApiOrigin(apiDomain: string): string {
  const origin = getOrigin();

  if (origin.includes(DOMAIN_LOCALHOST) || origin.includes(DOMAIN_OMO) || origin.includes(DOMAIN_PUSHWOOSH)) {
    return `https://${apiDomain}.svc-nue.pushwoosh.com`;
  }

  if (origin.includes(DOMAIN_WAVESEND) || origin.includes(DOMAIN_PUSHWOOSH_US)) {
    return origin.replace('sso.', `${apiDomain}.svc.`);
  }

  return origin.replace('sso.', `${apiDomain}.`);
}

export function getCdnOrigin(path: string): string {
  const origin = getOrigin();

  if (origin.includes(DOMAIN_LOCALHOST) || origin.includes(DOMAIN_OMO) || origin.includes(DOMAIN_PUSHWOOSH_US)) {
    return `https://cdn.pushwoosh.com${path}`;
  }

  return `${origin.replace('sso', 'cdn')}${path}`;
}

export function checkAllowShowConsent(): boolean {
  return !origin.includes(DOMAIN_WAVESEND) && !origin.includes(DOMAIN_OMO);
}

export function browserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}
